import axios from '@/http/index';

const base = '';
// 保存快捷收银信息
export const saveOrder = (param) => axios.post(`${base}/erp/quickCash/saveOrder`, param).then((res) => res.data);
// （结算）扫码支付--获取订单号
export const getOrderCode = (params) => axios.get(`${base}/erp/payInfo/getOrderCode`, params).then((res) => res.data);
// （结算）扫码支付--获取支付状态
export const getScanPayStatus = (params) => axios.get(`${base}/erp/payInfo/getScanPayStatus`, params).then((res) => res.data);
// （结算）扫码支付--3.6.0
export const newBarCodePay = (params) => axios.get(`${base}/erp/payInfo/barCodePay`, params).then((res) => res.data);
// 获取商家可支付方式：默认支付(0:未设置 2:通联支付,4:微信,5:支付宝,6:(包括支付宝，微信))
export const getPaySet = (params) => axios.get(`${base}/erp/payInfo/getPaySet`, params).then((res) => res.data);

// (3.8.0)获得店铺结算设置信息
export const getPayCodeList = (params) => axios.get(`${base}/erp/payInfo/getPayTypeSetList`, params).then((res) => res.data);

// （5.4）快捷收银扫码提交信息
export const toPayBefore = (params) => axios.post(`${base}/erp/quickCash/toPayBefore`, params).then((res) => res.data);
